import { createReducer, on, Action } from '@ngrx/store';
import * as GuidelinesNotSavedChangesActions from './guidelines-not-saved-changes.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const GUIDELINES_NOT_SAVED_CHANGES_FEATURE_KEY = 'guidelinesNotSavedChangesActions';

export interface GuidelinesNotSavedChangesEntity {
  id: string;
  listMinus: number;
  isListMinusValid: boolean;
  countryMsp: number;
  isCountryMspValid: boolean;
  countryId?: string;
}

export interface GuidelinesNotSavedChangesState {
  readonly [GUIDELINES_NOT_SAVED_CHANGES_FEATURE_KEY]: EntityState<GuidelinesNotSavedChangesEntity>;
}

export const guidelinesNotSavedChangesAdapter: EntityAdapter<GuidelinesNotSavedChangesEntity> =
  createEntityAdapter<GuidelinesNotSavedChangesEntity>();

export const initialGuidelinesNotSavedChangesState: EntityState<GuidelinesNotSavedChangesEntity> =
  guidelinesNotSavedChangesAdapter.getInitialState();

const reducer = createReducer(
  initialGuidelinesNotSavedChangesState,
  on(GuidelinesNotSavedChangesActions.updateNotSavedPartPricingState, (state, guidelinesNotSavedChangesEntity) =>
    guidelinesNotSavedChangesAdapter.upsertOne(guidelinesNotSavedChangesEntity, state)
  ),
  on(GuidelinesNotSavedChangesActions.removeAllNotSavedChanges, state =>
    guidelinesNotSavedChangesAdapter.removeAll(state)
  ),
  on(GuidelinesNotSavedChangesActions.removeNotSavedChangesByCountryId, (state, { countryId }) => {
    const idsToRemove = state.ids.map(id => id as string).filter(id => state.entities[id]?.countryId === countryId);

    return guidelinesNotSavedChangesAdapter.removeMany(idsToRemove, state);
  })
);

export function guidelinesNotSavedChangesReducer(
  state: EntityState<GuidelinesNotSavedChangesEntity> | undefined,
  action: Action
): EntityState<GuidelinesNotSavedChangesEntity> {
  return reducer(state, action);
}
